import { Link } from "react-router-dom";

/**
 * Anything the route table does not match.
 *
 * **There was no catch-all until 2026-09-05, and the cost was not theoretical.**
 * React Router renders nothing when no route matches, so every mistyped URL, and
 * every emailed link pointing at a route that had not been built, produced a
 * white page with no text, no navigation and nothing in the console. That is
 * indistinguishable from the application being broken, which is how the missing
 * `/reset/:token` route stayed invisible for five days.
 *
 * Deliberately outside `RequireAuth`: a signed-out person mistyping a URL should
 * see this rather than be bounced to a sign-in screen that does not explain what
 * happened.
 */
export function NotFoundPage(): React.JSX.Element {
  return (
    <main className="sheet-wide">
      <h1>That page is not here</h1>
      <p>
        The address may have been mistyped, or the link may be older than the screen it points at.
      </p>
      <p>
        <Link to="/">Go to your dashboard</Link> — or <Link to="/login">sign in</Link> if you are
        not signed in.
      </p>
    </main>
  );
}
